<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Meus pontos</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label>Ano</label>
              <select class="form-control" v-model="search.year">
                <option :value="year" v-for="year in years" :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <label>Mês</label>
              <select class="form-control" v-model="search.month">
                <option :value="month" v-for="month in months" :key="month">
                  {{ monthNames[month] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Ação</label>
              <button class="btn btn-block btn-info" @click="searchChecks">
                Buscar
              </button>
            </div>
          </div>
        </div>
        <!-- <h4>Banco de horas: {{ bankOfHours }}</h4> -->

        <button
          class="btn btn-success"
          id="check-check"
          @click.once="makeCheck"
          :disabled="loading"
          v-if="$store.state.user.remote_check > 0"
        >
          Marcar Ponto
        </button>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-hover">
              <thead>
                <th>Data</th>
                <th>Entrada</th>
                <th>Almoço</th>
                <th>Volta Almoço</th>
                <th>Saída</th>
                <th>Total</th>
                <th>Diferença</th>
              </thead>
              <tbody>
                <tr v-for="(check, index) in checks" :key="index">
                  <td>{{ formatDate(index) }}</td>
                  <td
                    :class="[
                      { 'text-gray': check[0] && check[0].solicitation },
                      { 'text-blue': check[0] && check[0].check_request_id },
                      { 'text-green': check[0] && check[0].remote },
                      { 'text-purple': check[0] && check[0].manual },
                      { 'text-orange': check[0] && check[0].vacation },
                    ]"
                  >
                    {{
                      check[0] && check[0].vacation == 1
                        ? "Férias"
                        : check[0]
                        ? format(check[0].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-gray': check[1] && check[1].solicitation },
                      { 'text-blue': check[1] && check[1].check_request_id },
                      { 'text-green': check[1] && check[1].remote },
                      { 'text-purple': check[1] && check[1].manual },
                      { 'text-orange': check[1] && check[1].vacation },
                    ]"
                  >
                    {{
                      check[1] && check[1].vacation == 1
                        ? "Férias"
                        : check[1]
                        ? format(check[1].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-gray': check[2] && check[2].solicitation },
                      { 'text-blue': check[2] && check[2].check_request_id },
                      { 'text-green': check[2] && check[2].remote },
                      { 'text-purple': check[2] && check[2].manual },
                      { 'text-orange': check[2] && check[2].vacation },
                    ]"
                  >
                    {{
                      check[2] && check[2].vacation == 1
                        ? "Férias"
                        : check[2]
                        ? format(check[2].created_at)
                        : ""
                    }}
                  </td>
                  <td
                    :class="[
                      { 'text-gray': check[3] && check[3].solicitation },
                      { 'text-blue': check[3] && check[3].check_request_id },
                      { 'text-green': check[3] && check[3].remote },
                      { 'text-purple': check[3] && check[3].manual },
                      { 'text-orange': check[3] && check[3].vacation },
                    ]"
                  >
                    {{
                      check[3] && check[3].vacation == 1
                        ? "Férias"
                        : check[3]
                        ? format(check[3].created_at)
                        : ""
                    }}
                  </td>
                  <td>{{ check[4] ? check[4] : "" }}</td>
                  <td>{{ check[6] ? check[6] : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checks: [],
      bankOfHours: "",
      search: {
        year: parseInt(moment().year(), 10),
        month: parseInt(moment().month(), 10),
      },
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      loading: false,
    };
  },
  computed: {
    years: function () {
      let lastYear = parseInt(moment().year(), 10);
      let availableYears = [];
      let firstYear = 2019;

      for (lastYear; lastYear >= firstYear; lastYear--) {
        availableYears.push(lastYear);
      }

      return availableYears;
    },
    months: function () {
      const self = this;
      let thisYear = parseInt(moment().year(), 10);
      let availableMonths = [];
      let lastMonth;

      if (self.search.year === thisYear) {
        lastMonth = parseInt(moment().month(), 10);
      } else {
        lastMonth = 11;
      }
      for (let i = 0; i <= lastMonth; i++) {
        availableMonths.push(i);
      }

      return availableMonths;
    },
  },
  methods: {
    makeCheck: function () {
      this.loading = true;
      const self = this;
      const api = this.$store.state.api + "checks/remoteCheck";

      self.$http
        .post(api)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Ponto Remoto criado com sucesso",
            "success"
          );
          self.searchChecks();
          self.loading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.loading = false;
        });
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    format: function (date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    searchChecks: function () {
      const self = this;
      const api =
        this.$store.state.api +
        "checks/myChecks?year=" +
        self.search.year +
        "&month=" +
        self.search.month;

      self.$http
        .get(api)
        .then((response) => {
          self.checks = response.data.organizedChecks;
          self.bankOfHours = response.data.bankOfHours;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.searchChecks();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Check/MyChecks.vue